import React, { useCallback, useEffect, useState } from 'react';
import { AdultAcademyCourseCard } from './AdultAcademyCourseCard';

// All Adult Academy courses (Academy page) or the single course of one booking (calendar details).
export const AdultAcademyPanel = ({ API, L, bookingId }) => {
  const [courses, setCourses] = useState(null);
  const load = useCallback(async () => {
    try {
      if (bookingId) {
        const { data } = await API.get(`/adult-academy/booking/${bookingId}`);
        setCourses(data ? [data] : []);
      } else {
        const { data } = await API.get('/adult-academy/courses');
        setCourses(data);
      }
    } catch { setCourses([]); }
  }, [API, bookingId]);
  useEffect(() => { load(); }, [load]);

  if (courses === null) return <p className="text-sm text-slate-400 py-4">…</p>;
  if (!courses.length) return <p className="text-sm text-slate-400 py-6 text-center" data-testid="aa-empty">{L('No Adult Academy courses', 'Keine Adult-Academy-Kurse')}</p>;
  return (
    <div className="space-y-4" data-testid="adult-academy-panel">
      {courses.map(c => <AdultAcademyCourseCard key={c.series_key} course={c} API={API} L={L} onChange={load} compact={!!bookingId} />)}
    </div>
  );
};
